// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__38aRv","sectionsWrapper":"style_sectionsWrapper__7hR8_"};